/*
  Restock · urgencia (sep-2026).
  Franja fina de arriba (dentro de la navegación fija) con la cuenta atrás REAL hasta el cierre de la
  ventana prioritaria, y el mismo dato dentro de la barra de pedido ([data-rs-urg-mini]).

  - La fecha de cierre es «venta para todos» del producto de referencia (Configuración del tema →
    «Restock · fases»). Si esa fecha ya pasó, la franja se quita sola y todo vuelve al estado normal.
  - Solo se enseña cuando esta persona ya puede comprar: fase BUY, o la ventana de la lista con el
    acceso de los emails (localStorage fh_restock_lista / ?acceso=lista).
  - QA: ?fase=buy la fuerza, ?fase=hype|tease la esconde.
*/
(function () {
  if (window.FHRestockUrgenciaJS) return; window.FHRestockUrgenciaJS = true;
  var PG = window.FHRestockPagina, doc = document, KEY = (PG && PG.cfg && PG.cfg.lsKey) || 'fh_restock_lista', timer = null;
  var qs; try { qs = new URLSearchParams(location.search) } catch (e) { qs = { get: function () { return null } } }
  if (qs.get('acceso') === 'lista') { try { localStorage.setItem(KEY, '1') } catch (e) {} }

  function band() { return doc.querySelector('[data-rs-urg]') }
  function cfgOf(b) { try { return JSON.parse(b.querySelector('[data-rs-urg-config]').textContent) } catch (e) { return null } }
  function access() { try { return localStorage.getItem(KEY) === '1' } catch (e) { return false } }
  function fases() { var P = window.FHRestockPagina; return (P && P.cfg && P.cfg.fases) || {} }
  function editor() { var P = window.FHRestockPagina; return (P && P.cfg && P.cfg.editor) || null }

  // «AAAA-MM-DD» + «HH:MM» en hora de Madrid → timestamp
  function madrid(d, h) {
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec((d || '').trim()), t = /^(\d{1,2}):(\d{2})$/.exec((h || '00:00').trim());
    if (!m || !t) return NaN;
    var guess = Date.UTC(+m[1], +m[2] - 1, +m[3], +t[1], +t[2]);
    try {
      var parts = {};
      new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Madrid', hourCycle: 'h23', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit' })
        .formatToParts(new Date(guess)).forEach(function (x) { parts[x.type] = x.value });
      return guess - (Date.UTC(+parts.year, +parts.month - 1, +parts.day, +parts.hour, +parts.minute) - guess);
    } catch (e) { return guess - 2 * 3600e3 }
  }

  function fechas(c) {
    var f = fases()[c.clave];
    if (f && f.buy && f.buy[0]) return { fin: madrid(f.buy[0], f.buy[1]), ini: madrid(f.lista[0], f.lista[1]), fm: f.fm };
    return { fin: madrid(c.fin && c.fin[0], c.fin && c.fin[1]), ini: NaN, fm: '' };
  }

  // ¿esta persona puede comprar ya?
  function abierta(d) {
    var ed = editor(); if (ed) return ed.fase === 'buy';
    var pf = qs.get('fase');
    if (pf === 'buy') return true;
    if (pf === 'hype' || pf === 'tease') return false;
    if (d.fm === 'buy') return true;
    if (d.fm === 'tease' || d.fm === 'hype') return false;
    var n = Date.now();
    if (!isNaN(d.fin) && n >= d.fin) return true;
    return !isNaN(d.ini) && n >= d.ini && access();
  }

  // Modo «preventa»: la franja acompaña mientras todavía NO se puede comprar (cuenta atrás hasta la venta)
  function preventa(d) {
    var ed = editor(); if (ed) return ed.fase === 'hype';
    var pf = qs.get('fase');
    if (pf === 'buy') return false;
    if (pf === 'hype') return true;
    return d.fm !== 'buy' && d.fm !== 'tease';
  }

  function dos(n) { return (n < 10 ? '0' : '') + n }
  function texto(ms, u) {
    var t = Math.max(0, Math.floor(ms / 1000));
    var d = Math.floor(t / 86400), h = Math.floor((t % 86400) / 3600), m = Math.floor((t % 3600) / 60), s = t % 60;
    if (d > 0) return d + ' ' + u.d + ' ' + dos(h) + ' ' + u.h + ' ' + dos(m) + ' ' + u.m + ' ' + dos(s) + ' ' + u.s;
    return dos(h) + ' ' + u.h + ' ' + dos(m) + ' ' + u.m + ' ' + dos(s) + ' ' + u.s;
  }

  // El reloj de la franja: una ficha por unidad («4 d», «16 h»…). Se montan una vez y luego solo cambian los números.
  function fichas(el, ms, u, leido) {
    var t = Math.max(0, Math.floor(ms / 1000));
    var v = { d: Math.floor(t / 86400), h: Math.floor((t % 86400) / 3600), m: Math.floor((t % 3600) / 60), s: t % 60 };
    if (!el.querySelector('[data-u]')) {
      el.textContent = '';
      ['d', 'h', 'm', 's'].forEach(function (k) {
        var s = doc.createElement('span'); s.className = 'rs-urg__u'; s.setAttribute('data-u', k); s.setAttribute('aria-hidden', 'true');
        s.appendChild(doc.createElement('b')); s.appendChild(doc.createElement('i')); el.appendChild(s);
      });
    }
    ['d', 'h', 'm', 's'].forEach(function (k) {
      var s = el.querySelector('[data-u="' + k + '"]'), n = k === 'd' ? String(v.d) : dos(v[k]);
      if (s.firstChild.textContent !== n) s.firstChild.textContent = n;
      if (s.lastChild.textContent !== u[k]) s.lastChild.textContent = u[k];
      if (k === 'd') s.hidden = v.d === 0;
    });
    if (el.getAttribute('aria-label') !== leido && v.s % 15 === 0) el.setAttribute('aria-label', leido);
  }

  function tick() {
    var b = band(); if (!b) return;
    var c = cfgOf(b); if (!c) return;
    var d = fechas(c), restante = d.fin - Date.now();
    var on = !isNaN(d.fin) && restante > 0 && (c.modo === 'preventa' ? preventa(d) : abierta(d));
    b.hidden = !on;
    var mini = doc.querySelectorAll('[data-rs-urg-mini]');
    if (!on) { mini.forEach(function (el) { el.hidden = true }); return }
    var txt = texto(restante, c.unidades || { d: 'd', h: 'h', m: 'm', s: 's' });
    var t = b.querySelector('[data-rs-urg-time]');
    if (t) fichas(t, restante, c.unidades || { d: 'd', h: 'h', m: 'm', s: 's' }, txt);
    mini.forEach(function (el) {
      el.hidden = false;
      var v = el.querySelector('[data-rs-urg-mini-time]') || el;
      if (v.textContent !== txt) v.textContent = txt;
    });
  }

  // El botón de la franja abre la barra de pedido si está; si no, baja al ancla indicada.
  doc.addEventListener('click', function (e) {
    var t = e.target; if (!t.closest) return;
    // el botón de la franja; en el móvil (sin botón), la franja entera
    var enFranja = t.closest('[data-rs-urg]'), movil = window.matchMedia && window.matchMedia('(max-width: 749px)').matches;
    if (!t.closest('[data-rs-urg-cta]') && !(enFranja && movil)) return;
    var b = band(), c = b && cfgOf(b);
    var toggle = doc.querySelector('[data-rs-ped]:not([aria-hidden="true"]) [data-rs-ped-toggle]');
    if (toggle) { e.preventDefault(); toggle.click(); return }
    var anc = c && c.cta_ancla;
    if (!anc) return;
    e.preventDefault();
    var dest = null; try { dest = anc.charAt(0) === '#' ? doc.getElementById(anc.slice(1)) : null } catch (err) {}
    if (dest && dest.getClientRects().length) { // ancla de la página: baja suave y deja el cursor en su formulario
      var nav = doc.querySelector('.rsn-section') || doc.querySelector('.rsn'), off = nav ? nav.getBoundingClientRect().height : 0;
      window.scrollTo({ top: Math.max(0, dest.getBoundingClientRect().top + window.pageYOffset - off - 16), behavior: 'smooth' });
      var inp = dest.querySelector('input[type=email]'); if (inp && inp.getClientRects().length) setTimeout(function () { try { inp.focus({ preventScroll: true }) } catch (x) {} }, 500);
      return;
    }
    try { location.href = anc } catch (err) {}
  });

  function init() {
    if (!band()) return;
    tick();
    if (timer) clearInterval(timer);
    timer = setInterval(tick, 1000);
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();
  doc.addEventListener('shopify:section:load', init);
  doc.addEventListener('rs:ver', tick);
  doc.addEventListener('rs:hub', init);
  doc.addEventListener('rs:contenido', init);
})();
